import { AxiosResponse } from 'axios';
import queryString from 'query-string';

import { RequestsLog } from '../types/RequestLog';
import HttpClient, { Metadata } from '../utils/HttpClientHandler';
import PaginationHandler from '../utils/PaginationHandler';

const JobService = class JobService {
    #baseURL: string;

    constructor() {
        this.#baseURL = '/dashboard/logs';
    }

    private setQueryStringParams(filters: { [key: string]: any }): string {
        return queryString.stringify(filters, { arrayFormat: 'comma', skipEmptyString: false, skipNull: true });
    }

    public async getAllRequestLogs(filters = {}): Promise<{ data: RequestsLog[]; _metadata: Metadata }> {
        const qsFilters = Object.keys(filters).length !== 0 ? `?${this.setQueryStringParams(filters)}` : '';
        const response: AxiosResponse = await HttpClient.get(`${this.#baseURL}${qsFilters}`);
        const { data, headers }: { data: RequestsLog[]; headers: any } = response;

        return {
            data,
            _metadata: {
                pagination: new PaginationHandler(headers),
            },
        };
    }
};

export default new JobService();
